import { SVGProps } from 'react'

const SpinnerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.45"
      d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM1.96 7C1.96 9.78351 4.21649 12.04 7 12.04C9.78351 12.04 12.04 9.78351 12.04 7C12.04 4.21649 9.78351 1.96 7 1.96C4.21649 1.96 1.96 4.21649 1.96 7Z"
      fill="currentColor"
    />
    <path
      d="M14 7C14 5.89533 13.7386 4.80634 13.237 3.82207C12.7355 2.8378 12.0082 1.98619 11.1145 1.33688C10.2208 0.687571 9.18611 0.25899 8.09504 0.0861816C7.00397 -0.086627 5.88749 0.00124168 4.83688 0.342605C3.78627 0.683968 2.83137 1.26913 2.05025 2.05025C1.26913 2.83137 0.683967 3.78627 0.342604 4.83688C0.00124162 5.88749 -0.0866273 7.00397 0.0861817 8.09504C0.258991 9.18611 0.687571 10.2208 1.33688 11.1145L2.92255 9.96244C2.45505 9.31897 2.14647 8.574 2.02205 7.78843C1.89763 7.00286 1.96089 6.19899 2.20668 5.44255C2.45246 4.68612 2.87377 3.99859 3.43618 3.43618C3.99859 2.87377 4.68612 2.45246 5.44255 2.20668C6.19899 1.96089 7.00286 1.89763 7.78843 2.02205C8.574 2.14647 9.31897 2.45505 9.96244 2.92255C10.6059 3.39006 11.1296 4.00321 11.4907 4.71189C11.8518 5.42056 12.04 6.20464 12.04 7H14Z"
      fill="currentColor"
    />
  </svg>
)
export default SpinnerIcon
